module.exports = __webpack_public_path__ + "static/img/hsbc.5a69b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hsbc.png
// module id = D/Cu
// module chunks = 1